import React from 'react';
import './EmptyTodos.css';

function EmptyTodos() {
  return <p className='Register'>¡Register your first Signing!<br className='regspace'></br>
     Use the + button to add a new Signing
  </p>;
}

export { EmptyTodos };